import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Team} from '../contracts/team.interface';
import { TableFilter } from '../../shared/contracts/table-column.interface';

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  private API_URL = 'teams/';

  constructor(private http: HttpClient) {}

  getAll(page = 1, size = 10, filters: TableFilter[] = []): Observable<{ data: Team[]; total: number }> {
    let params = new HttpParams().set('page', page).set('size', size);
    for (const f of filters) {
      params = params.append('filter_field', f.field);
      params = params.append('filter_value', f.value);
      params = params.append('filter_match', f.matchMode);
    }
    return this.http.get<{ data: Team[]; total: number }>(this.API_URL, { params });
  }

  create(team: Team): Observable<Team> {
    return this.http.post<Team>(this.API_URL, team);
  }

  update(id: number, team: Team): Observable<Team> {
    return this.http.put<Team>(`${this.API_URL}${id}`, team);
  }

  delete(id: number): Observable<Team> {
    return this.http.delete<Team>(`${this.API_URL}${id}`);
  }
}
